import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import BuyerUserName from "../../components/buyerUser/BuyerUserDetail/BuyerUserName.tsx";
import {useLocationFormState} from "../../components/buyerUser/BuyerUserForm/BuyerUserUpdateForm";
import BuyerUserUpdateFormProvider from "../../components/buyerUser/BuyerUserForm/BuyerUserUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const BuyerUserUpdateEditPage = () => {
    
    useTitle(t`Update Buyer User`);

    const { buyerUserId: id } = useParams();
    
    return (
        <Box data-testid="BuyerUser-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="BuyerUser-update-title"
                    >
                        <Trans>Edit Buyer User</Trans>:  <BuyerUserName id={id}/>
                    </Typography>
                    <BuyerUserUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default BuyerUserUpdateEditPage;
